
import {
  computed, defineComponent, ref, onMounted, onBeforeUnmount,
} from '@vue/composition-api';
import { Video, FCButton } from '@fc/angie-ui';
import debounce from 'lodash/debounce';
import { isMobileEffect } from '~/effects/matchMedia';

const sectionsData = [
  {
    header: 'Boxing & Kickboxing Workouts',
    text: '3-minute rounds with a 1-minute rest. Perfect for any schedule — get it all out in 15 to 45 minutes.',
    video: {
      mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/boxing-kickboxing-highlight.mp4',
      webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/boxing-kickboxing-highlight.webm',
      firstFrameImage: 'https://a.storyblok.com/f/152150/1920x1080/dd398579e7/16x9-boxing-kickboxing-highlight.jpg',
    },
  },
  {
    header: 'Tutorials',
    text: 'Beginner-friendly with no experience needed, our programs teach the fundamentals to help you become a skilled martial artist step by step.',
    video: {
      mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/SHOP+PAGE+TUTORIAL+HIGHLIGHT+(small).mp4',
      firstFrameImage: 'https://a.storyblok.com/f/152150/1920x1080/08e6567901/16x9-tutorials-highlight.jpg',
    },
  },
  {
    header: 'Strength & Conditioning',
    text: 'Grab your weights to build muscle, strength, and endurance.',
    video: {
      mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/SHOP+PAGE+STRENGTH+%2B+CONDITIONING+HIGHLIGHT+(small).mp4',
      firstFrameImage: 'https://a.storyblok.com/f/152150/1920x1080/d5a1251a23/16x9-s-c-highlight.jpg',
    },
  },
  {
    header: 'Core Workouts',
    text: 'It\'s our golden rule: always end with abs.',
    video: {
      mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/core-highlight.mp4',
      webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/CORE+HIGHLIGHT.webm',
      firstFrameImage: 'https://a.storyblok.com/f/152150/1920x1080/05aace5e7b/16x9-core-highlight.jpg',
    },
  },
  {
    header: 'Nutrition',
    text: 'Fuel your fitness with expert-backed nutrition tips, used by top fighters to cut weight and stay fight ready.',
    video: {
      mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/nutrition-highlight.mp4',
      firstFrameImage: 'https://a.storyblok.com/f/152150/1920x1080/0ebf7b7ba4/16x9-nutrition-highlight.jpg',
    },
  },
  {
    header: 'Stretch',
    text: 'Enhance mobility, stimulate recovery, and prevent injuries.',
    video: {
      mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/SHOP+PAGE+STRETCH+HIGHLIGHT+(small).mp4',
      firstFrameImage: 'https://a.storyblok.com/f/152150/1920x1080/db4a6bad68/16x9-stretch-highlight.jpg',
    },
  },
];

export default defineComponent({
  name: 'DropDownVideos',
  components: {
    Video,
    FCButton,
  },
  setup() {
    const sections = computed(() => sectionsData.map((section, index) => ({
      ...section,
      isExpanded: isExpanded(index),
      animationClass: isExpanded(index) ? 'active' : 'inactive',
    })));

    const currentIndex = ref(0);
    const activeDesktopVideo = computed(() => sections.value[currentIndex.value]);

    function isExpanded(index: number) {
      return currentIndex.value === index;
    }

    function toggleExpanded(index: number) {
      currentIndex.value = index;
    }

    // @ts-ignore
    const { $device } = useNuxtApp();

    // this creates a fallback value for the isMobile variable for server side rendering
    const isMobile = ref(false);
    const checkIfMobile = () => { isMobile.value = isMobileEffect().value; };
    const debouncedCheckIfMobile = debounce(checkIfMobile, 200);
    onMounted(() => {
      checkIfMobile();
      window.addEventListener('resize', debouncedCheckIfMobile);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', debouncedCheckIfMobile);
    });

    return {
      sections,
      isExpanded,
      toggleExpanded,
      currentIndex,
      isSafari: computed(() => $device.isSafari),
      isMobile,
      activeDesktopVideo,
    };
  },
});

